const mockEvents = {
  city: {
    id: 1007700,
    city: 'München',
    lat: 48.14,
    lon: 11.58,
    state: '',
    country: 'de',
    zip: 'meetup3',
    member_count: 1257
  },
  events: [
    {
      created: 1581975191000,
      duration: 7200000,
      fee: {
        accepts: 'wepay',
        amount: 5,
        currency: 'USD',
        description: '',
        label: 'Price',
        required: true
      },
      id: '268785462',
      name: 'Easter Hike: Waterfalls & Rivers at Scotts Run Preserve! A Moderate 4-Mile Hike',
      rsvp_limit: 10,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1586700000000,
      local_date: '2020-04-12',
      local_time: '10:00',
      updated: 1584634726000,
      utc_offset: -14400000,
      waitlist_count: 0,
      yes_rsvp_count: 7,
      venue: {
        id: 1236584,
        name: 'Scotts Run Nature Preserve and Waterfall with Mid-Atlantic Hiking Group! A Moderate 4 Mile Hike',
        lat: 38.63013458251953,
        lon: -78.5206527709961,
        repinned: true,
        address_1: 'Directions: Click the link under “Directions to the Trailhead” located near the end of the event listing.',
        address_2: 'The linked page has location/direction details, driving/parking info, including where to Meetup after you arrive.',
        city: ' ',
        country: 'us',
        localized_country_name: 'USA',
        zip: '',
        state: 'VA'
      },
      group: {
        created: 1185015652000,
        name: 'Mid-Atlantic Hiking Group — A 501(c)(3) Charitable Org.',
        id: 579832,
        join_mode: 'approval',
        lat: 38.90999984741211,
        lon: -77.0199966430664,
        urlname: 'Mid-Atlantic-Hiking-Group',
        who: 'Outdoor Enthusiasts',
        localized_location: 'Washington, DC',
        state: 'DC',
        country: 'us',
        region: 'en_US',
        timezone: 'US/Eastern'
      },
      link: 'https://www.meetup.com/Mid-Atlantic-Hiking-Group/events/268785462/',
      description: '<p>Easter Hike to See Waterfalls &amp; Rivers at Scotts Run Preserve! A Moderate 4-Mile Hike</p> <p><img src=\'http://photos3.meetupstatic.com/photos/event/7/7/7/c/600_445470588.jpeg\' /></p> <p>\'This hike features river views, a waterfall, wildflowers, amphibian breeding areas in spring, and some fascinating ruins as well. It includes Palisades along the Potomac and the rocky lower end of Scotts Run.\'</p> <p>Visitors have flocked to Scotts Run for years to witness the spring wildflowers that grow there. Sources say that trailing arbutus, Virginia bluebells, and trillium blooming on the steep hillsides create a small oasis of rare and fragile plants. Remarkable and rare species grow along the precipitous cliffs, in steep valleys and throughout the mature hardwood forest of huge oak and beech trees, ancient hemlock and wild cherry trees that stand as tall as the oaks.</p> <p>Scotts Run Nature Preserve consists of a rather hilly, wildflower-riddled tract of riverside woodlands scarcely four crow-miles northwest of Washington. For songbirds and other wildlife, it’s an actual sanctuary.</p> <p><img src=\'http://photos3.meetupstatic.com/photos/event/7/7/a/b/600_445470635.jpeg\' /></p> <p>Trail Information</p> <p>Activity Type: Hiking<br/>Nearby City: McLean (Very near DC but you would never know it! In the vicinity of Great Falls)<br/>Scenery: Rolling woodlands, river views, and seasonal wildflowers<br/>Exposure: Mostly shady with a couple of open areas where it is somewhat sandy near the river.<br/>Trail Surface: Mostly dirt or gravel; rocky, rooty near the river. There are some boulders too.<br/>Length: 4 total miles<br/>Elevation Gain: 1,900 feet but in undulating hills<br/>Trail Type: Our hike plan is a modified loop<br/>Skill Level: Moderate<br/>Season: Year-round<br/>Local Maps: USGS Falls Church, PATC Map D<br/>Facilities: None</p> <p><img src=\'http://photos1.meetupstatic.com/photos/event/7/7/9/1/600_445470609.jpeg\' /></p> <p>Park Entry Fee<br/>There is no park entrance fee.</p> <p>Gear Suggestions<br/>Click Here (<a href=\'http://midatlantichikinggroup.org/gear-information.html\' class=\'linkified\'>http://midatlantichikinggroup.org/gear-information.html</a>) for suggestions regarding what to wear and what not to wear for hiking the trails.</p> <p>Weather Information<br/>We hike rain or shine. Click Here (<a href=\'http://www.weather.com/weather/today/McLean+VA+USVA0485?from=enhsearch_didyoumean\' class=\'linkified\'>http://www.weather.com/weather/today/McLean+VA+USVA0485?from=enhsearch_didyoumean</a>) to view the forecast for the area where we will be hiking.</p> <p>Our RSVP and Group Etiquette<br/>Click Here (<a href=\'http://www.meetup.com/Maryland-Hiking/pages/RSVP_Rules_and_Etiquette/\' class=\'linkified\'>http://www.meetup.com/Maryland-Hiking/pages/RSVP_Rules_and_Etiquette/</a>) to review our RSVP policies and group etiquette.</p> <p><img src=\'http://photos2.meetupstatic.com/photos/event/7/7/b/1/600_445470641.jpeg\' /></p> <p>Carpool Suggestions and Information</p> <p>Note that you are responsible for knowing how to get from carpool locations to the venue. Mid-Atlantic Hiking Group is not responsible for transportation to and from events or carpools. Suggested carpool times and places are provided as a courtesy because many members are either new to the area or unfamiliar with a particular hike or venues location. Please use the \'Comments\' section below, or reach out via e-mail to make arrangements for carpooling needs and offerings.</p> <p>Baltimore Area Carpool Suggestion - Savage Station<br/>To carpool or caravan from the Baltimore area, people can arrange to meet at Savage Station. Click Here (<a href=\'http://www.meetup.com/Maryland-Hiking/pages/Carpool_Directions_for_Savage_Station/\' class=\'linkified\'>http://www.meetup.com/Maryland-Hiking/pages/Carpool_Directions_for_Savage_Station/</a>) for directions and additional information regarding carpooling from the suggested Savage Station location.</p> <p>If you can drive or want to carpool from additional locations, please post your location and needs in the comment section below. Click Here (<a href=\'http://www.meetup.com/Mid-Atlantic-Hiking-Group/pages/Suggested_Carpool_Locations/?name=Suggested_Carpool_Locations\' class=\'linkified\'>http://www.meetup.com/Mid-Atlantic-Hiking-Group/pages/Suggested_Carpool_Locations/?name=Suggested_Carpool_Locations</a>) for a list of suggested carpool locations complete with directions and other details including other carpool information. For those who need a ride, reach out to the drivers. Make friends, and support the environment — by just offering a ride!</p> <p><img src=\'http://photos1.meetupstatic.com/photos/event/7/7/a/2/600_445470626.jpeg\' /></p> <p>Directions to the Trailhead<br/>Click Here for Directions (<a href=\'http://midatlantichikinggroup.org/scotts-run.html\' class=\'linkified\'>http://midatlantichikinggroup.org/scotts-run.html</a>) to Where We Meet for This Hike</p> <p>Meet &amp; Greet and Sign-In — 9:45-9:55 a.m.</p> <p>The Hike is at 10:00 a.m.</p> <p>Please remember we are a volunteer-supported organization that values fellowship and camaraderie while practicing good hike etiquette (<a href=\'http://midatlantichikinggroup.org/hike-and-trail-etiquette.html)and\' class=\'linkified\'>http://midatlantichikinggroup.org/hike-and-trail-etiquette.html)and</a> Leave No Trace (<a href=\'http://midatlantichikinggroup.org/leave-no-trace.html\' class=\'linkified\'>http://midatlantichikinggroup.org/leave-no-trace.html</a>) principles. Our hikes are led by generous, dedicated, and qualified MAHG members who volunteer (<a href=\'http://www.meetup.com/Mid-Atlantic-Hiking-Group/pages/9595722/How_To_Join_Our_Leadership_Team!/\' class=\'linkified\'>http://www.meetup.com/Mid-Atlantic-Hiking-Group/pages/9595722/How_To_Join_Our_Leadership_Team!/</a>) as leaders for Mid-Atlantic Hiking Groups volunteer leadership team. Hikes also have a volunteer “sweeper” to help ensure that no hiker is left behind. MAHG volunteers and members are very supportive, encouraging, with a focus on safety while enjoying the excellent camaraderie and benefiting from the many health benefits of hiking and unplugging from the stress of day-to-day life. Sharing what we know and learning from each other is an important part of MAHGs core values, as is our dedication to the conservation of our natural resources and our commitment to the organization\'s mission (<a href=\'http://midatlantichikinggroup.org/\' class=\'linkified\'>http://midatlantichikinggroup.org/</a>). Mid-Atlantic Hiking Group is a volunteer-supported tax-exempt 501(c)(3) nonprofit charitable organization, (<a href=\'http://midatlantichikinggroup.org/mahg-charity.html\' class=\'linkified\'>http://midatlantichikinggroup.org/mahg-charity.html</a>) and donations ARE tax deductible (<a href=\'https://midatlantichikinggroup.networkforgood.com/projects/17107-fall-into-hiking-for-health\' class=\'linkified\'>https://midatlantichikinggroup.networkforgood.com/projects/17107-fall-into-hiking-for-health</a>). Tax ID:[masked] (<a href=\'http://midatlantichikinggroup.org/mahg-charity.html\' class=\'linkified\'>http://midatlantichikinggroup.org/mahg-charity.html</a>).</p> <p>A Well-Mannered, Leashed Fido is Welcome on this Hike!</p> <p>Let’s have fun out on the trails and see you there!</p> <p>Mike:\u202c</p> <p><img src=\'http://photos3.meetupstatic.com/photos/event/d/4/f/2/600_451494514.jpeg\' /></p> <p>• Please Click Here Now (<a href=\'https://secure.meetup.com/Mid-Atlantic-Hiking-Group/contribute/)and\' class=\'linkified\'>https://secure.meetup.com/Mid-Atlantic-Hiking-Group/contribute/)and</a> Help Mid-Atlantic Hiking Group with Serving our Mission (<a href=\'http://midatlantichikinggroup.org/index.html\' class=\'linkified\'>http://midatlantichikinggroup.org/index.html</a>).</p> <p>• Donations (<a href=\'https://midatlantichikinggroup.networkforgood.com/projects/33981-sponsor-a-veteran-today\' class=\'linkified\'>https://midatlantichikinggroup.networkforgood.com/projects/33981-sponsor-a-veteran-today</a>) to Mid-Atlantic Hiking Group are Tax Deductible: Tax ID[masked] (<a href=\'http://midatlantichikinggroup.org/mahg-charity.html\' class=\'linkified\'>http://midatlantichikinggroup.org/mahg-charity.html</a>). Mid-Atlantic Hiking Group is a 501(c)(3) non-profit public charitable organization.</p> <p>• Click Here (<a href=\'http://www.meetup.com/Mid-Atlantic-Hiking-Group/about/\' class=\'linkified\'>http://www.meetup.com/Mid-Atlantic-Hiking-Group/about/</a>) to Learn more about Mid-Atlantic Hiking Group’s Mission.</p> <p>• 100% of Every Dollar Goes Directly to the Expenses of Serving our Mission!!!</p> ',
      how_to_find_us: 'Use the link provided under the paragraph heading “Directions to the Trailhead” located near the bottom of the event posting. It provides important information such as directions to the event, where we Meetup after you arrive, and other helpful info.',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1582098084000,
      duration: 17940000,
      id: '1',
      name: 'Games Lounge',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1589648400000,
      local_date: '2020-04-11',
      local_time: '19:00',
      updated: 1582098084000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 2,
      venue: {
        id: 2,
        name: 'Werk 1 München',
        lat: 48.12443542480469,
        lon: 11.607304573059082,
        repinned: true,
        address_1: 'Grafinger Str. 6',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1393492592000,
        name: 'Games Lounge',
        id: 3,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Games-Lounge',
        who: 'Gamer',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Games-Lounge/events/268821281/',
      description: '<p>Games Lounge is a regular event of the Videospielkultur e.V. at the event space of Werk 1 München near Ostbahnhof.</p> <p>You can find Werk 1 here: <a href="https://www.werk1.com/wp-content/uploads/sites/2/2019/04/wegbeschreibung_werk1_maerz_2.pdf" class="linkified">https://www.werk1.com/wp-content/uploads/sites/2/2019/04/wegbeschreibung_werk1_maerz_2.pdf</a></p> <p>We meet on Saturdays twice per month to play videogames from our extensive archive of old and new games. There are always different gaming stations available with something for everyone.</p> <p>There is no entry fee and free non-alcoholic drinks are available.</p> <p>If you haven\'t been to Games Lounge before you can find some impressions here: <a href="https://www.facebook.com/groups/videospielkultur/photos/" class="linkified">https://www.facebook.com/groups/videospielkultur/photos/</a></p> ',
      how_to_find_us: 'https://www.werk1.com/wp-content/uploads/sites/2/2019/04/wegbeschreibung_werk1_maerz_2.pdf',
      visibility: 'public_limited',
      member_pay_fee: false
    },
    {
      created: 1574867945000,
      duration: 1209600000,
      id: '4',
      name: 'Oneway Törn Athen - Preveza: halbe Drehung um den Peloponnes',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1589025600000,
      local_date: '2020-04-11',
      local_time: '14:00',
      updated: 1574868483000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 4,
      group: {
        created: 1520018472000,
        name: 'München Segeln Meetup',
        id: 5,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Munchen-Segeln-Meetup',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Munchen-Segeln-Meetup/events/266781157/',
      description: '<p>Wir (mein Co-Skipper &amp; ich) segeln mit einer 40er Segelyacht (eine Elan Impression, Baujahr 2010) von Athen nach Preveza. Bevorzugt laufen wir bei passendem Wetter die längere Strecke südlich herum, alternativ passieren wir den Graben von Korinth.<br/>Wir würden gerne noch ein paar segellustige Leute mitnehmen: Spaß am mitmachen ist nötig - aber Segel-Kenntnisse sind *nicht* erforderlich =8-)</p> <p>Die Charter beläuft sich auf ca. 750,- (+ ca. 90,- NK für Transit-log und Versicherung) für 2 Wochen und 1 Koje, ggf. entsprechend für 1 Kabine (=2 Kojen).</p> <p>Dieses "Event" ist keine kommerzielle Veranstaltung, vielmehr eine private Unternehmung aus Spaß am Segeln: "Teilnehmen" klicken ist somit nicht verbindlich, sondern verstehe ich zunächst nur als Interessensbekundung.<br/>Wer Lust hat mitzukommen sagt also gerne zu oder schreibt mir per PN: wir werden uns ggf. unkompliziert treffen um Details zu klären.</p> ',
      visibility: 'public',
      member_pay_fee: false
    },

    {
      created: 1581637409000,
      duration: 10800000,
      id: '6',
      name: 'Unternehmertreffen & Start up-Event in München',
      rsvp_limit: 30,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1586102400000,
      local_date: '2020-04-05',
      local_time: '18:00',
      updated: 1581975365000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 30,
      venue: {
        id: 7,
        name: 'The Flushing Meadows Bar, Frauenhoferstraße 32, 80469 München',
        lat: 48.128822326660156,
        lon: 11.574684143066406,
        repinned: false,
        address_1: 'Frauenhoferstraße 32, 80469 München',
        city: 'München',
        country: 'DE',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1581635431000,
        name: 'Unternehmertreffen and Start up-Event "München"',
        id: 8,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Unternehmertreffen-Start-up-Event-Munchen',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Unternehmertreffen-Start-up-Event-Munchen/events/268694342/',
      description: '<p>DAS UNTERNEHMERTREFFEN „MÜNCHEN“ STARTUP EVENT</p> <p>INVESTOREN / BUSINESS-ANGEL*<br/>*mehr Details in der Beschreibung</p> <p>Das Unternehmertreffen Munich-Milan ist das Forum für Geschäftsfreunde in ganz Deutschland. Wir hören gemeinsam spannende Vorträge, veranstalten Aktionen, haben Zeit für informelle Gespräche und bahnen Geschäfte an.</p> <p>Wir sind überparteilich und unabhängig. Und vor allem: Wir haben viel Spaß am Netzwerken!</p> <p>Zahlreiche UNTERNEHMER und STARTUP UNTERNEHMEN aus dem Raum München nehmen teil und freuen sich über Jeden, der unser Netzwerk weiter verstärkt. AUCH STUDENTEN MIT GUTEN IDEEN SIND HERZLICH WILLKOMMEN.</p> <p>Informationen und Tickets finden sich unter: <a href="https://www.munich-milan.de/cms/de/unternehmertreffen-muenchen-1" class="linkified">https://www.munich-milan.de/cms/de/unternehmertreffen-muenchen-1</a></p> <p>Gerne auch per Telefon: Christian Lenk +49 (0)[masked]</p> <p>Ablauf:<br/>Begrüßung<br/>Kurze Vorstellungsrunde:<br/>- Name, Alter, Herkunft<br/>- Aktuelle Geschäftsbereiche und Projekte</p> <p>Anschließend dürfen 2 freiwillige Unternehmer ihre Geschäfte/ Projekte der Gruppe vorstellen, jeweils circa 15 Minuten.</p> <p>Nach jeder Runde wird eine Unterstützerrunde (Nutzung der Schwarmintelligenz) eingeleitet, wo die Anwesenden für das vorgestellte Projekt zB.:<br/>- Helfende Kontakte zusprechen können<br/>- Ideen zur Förderung des Geschäfts einbringen dürfen<br/>- Selbst Interesse äußern können, um neue Geschäftsbeziehungen anzubahnen.</p> <p>Wenn du einen interessanten Partner kennengelernt hast, könnt ihr eure Visitenkarten austauschen. Diese Runde ist ebenfalls mit 15 Minuten angesetzt.</p> <p>Abschließend wird das Treffen mit einem Referenten aus dem Forex Markt oder Krypto Bereich abgerundet und offen ausgetauscht.</p> <p>Dein Mehrwert<br/>Du lernst jeden Teilnehmer persönlich kennen, wodurch dein Netzwerk sehr schnell wächst. Durch neue Geschäftskontakte und den sich daraus ergebenden Möglichkeiten, kannst du große Umsatzsteigerungen erzielen. Du lernst regionale Geschäftspartner kennen, die, wie auch du, etwas erreichen und schaffen wollen. Gemeinsam könnt ihr eure Ideen schneller und einfacher umsetzen.</p> <p>Informelle Gespräche<br/>Nach dem offiziellen Teil des Unternehmertreffens, in dessen Mittelpunkt die Nutzung der Schwarmintelligenz für die vorgestellten Projekte steht, geht es mit lockerem Netzwerken und viel informellem Austausch weiter. So entstehen echte Geschäftsfreundschaften.</p> <p>Netzwerken<br/>Netzwerke bilden heute die Basis für viele unternehmerische Aktivitäten. Genau dies ist der Grundgedanke von Munich-Milan Wir machen miteinander Geschäfte, unterstützen uns gegenseitig – und haben auch eine Menge Spaß.</p> <p>Melde dich jetzt für Sonntag an und wir sehen uns beim Unternehmertreffen!<br/>Anmelden ist Pflicht: Nach vielen Nachfragen noch der Gästelistelink:<br/><a href="https://www.munich-milan.de/cms/de/unternehmertreffen-muenchen-1" class="linkified">https://www.munich-milan.de/cms/de/unternehmertreffen-muenchen-1</a></p> <p>Nur wer die Reservierung für 20,00 Euro bestätigt kann kommen.</p> <p>An der Tür "The Flushing Meadows Bar, Frauenhoferstraße 32, 80469 München" " bitte die Bestätigung vorzeigen:</p> <p>OHNE TICKET KEIN EINLASS!<br/>Wir freuen uns auf dich und deine Idee</p> <p>INFO INVESTOREN - BUSINESSANGEL:<br/>Wir laden regelmäßig Investoren ein, die sich neue Startup Ideen anschauen. Ein Investor stellt sich nie als Investor vor. Er wird mit dir Kontakt aufnehmen, sollte deine Idee interessant sein!</p> ',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1582811091000,
      duration: 10800000,
      id: '9',
      name: 'WERKSAcademy #15 | "Go to Market: Customer centric to traction"',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1587481200000,
      local_date: '2020-04-21',
      local_time: '17:00',
      updated: 1582811114000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 13,
      venue: {
        id: 10,
        name: 'WERK1',
        lat: 48.12380599975586,
        lon: 11.608254432678223,
        repinned: true,
        address_1: 'Atelierstraße 29',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1458124246000,
        name: 'WERK1',
        id: 11,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'WERK1munich',
        who: 'movers and shakers',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/WERK1munich/events/269032576/',
      description: '<p>TICKETS ARE ONLY SOLD THROUGH EVENTBRITE<br/><a href="https://www.eventbrite.de/e/werksacademy-pow-by-tractionwise-go-to-market-customer-centric-to-traction-tickets-96430896407" class="linkified">https://www.eventbrite.de/e/werksacademy-pow-by-tractionwise-go-to-market-customer-centric-to-traction-tickets-96430896407</a></p> <p>Why this workshop format exists</p> <p>Too many companies are far away from customers, do a lot, but still don\'t bring their power to the ground. Those responsible in companies often fall into the pattern of "Build it and they will come". They lock themselves in and polish products and services. All too often, they are far away from the actual needs of the customer. As a result, founders, marketers and salespeople often speak a completely different language than their customers. This ultimately leads to the failure of a product launch or market entry, or at least to burning of enormous resources.</p> <p>Workshop Overview</p> <p>Customer Insights:<br/>We develop a sharp customer profile within a buying center. In doing so, we rely on elements of customer development to achieve the Problem-Solution Fit.</p> <p>Value Proposition Design:<br/>We develop a stringent storyline easy to understand for the customer and covering various stages. This makes everyone in the team who potentially comes into contact with customers able to speak.</p> <p>Channel Execution:<br/>From a basic structure and impartiality to a sustainable marketing portfolio, we lay the foundation for a functioning Go to Market.<br/>When: Tuesday, April 21st @5 - 8PM -- presentation, followed by discussion, networking &amp; drinks</p> <p>Where: WERK1, Atelierstr. 29 (room: „Workshopraum”)</p> <p>Who: Startups &amp; Coworker from the Munich ecosystem</p> <p>Speaker: André Wehr I Co-Founder &amp; CEO - tractionwise</p> <p>The event will be in English.</p> ',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1582987679000,
      duration: 5400000,
      id: '12',
      name: 'Begleitgruppe der edulabs zum EBmoocplus2020 7. Treffen',
      rsvp_limit: 15,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1588001400000,
      local_date: '2020-04-27',
      local_time: '17:30',
      updated: 1582987679000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 1,
      venue: {
        id: 13,
        name: 'WikiMUC Wikipedia',
        lat: 48.13136291503906,
        lon: 11.57040786743164,
        repinned: true,
        address_1: 'Angertorstraße 3',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1529326085000,
        name: 'edulabs München',
        id: 14,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'edulabs-Munchen',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/edulabs-Munchen/events/269086368/',
      description: '<p>Die edulabs München bieten zum EBmoocplus2020 eine Begleitgruppe an. Wir treffen dazu in den Räumen von Wikipedia in München oder im Café Netzwerk des KJR München.</p> <p>Inhalt des 8. Moduls:<br/>In diesem Modul lernen ErwachsenenbildnerInnen einfache Webinar- und Videokonferenz-Technologien für den Einsatz in der Erwachsenenbildung kennen. Sie erfahren dabei Grundlegendes über Formate wie Online-Podiumsdiskussionen, Online- Gesprächsrunden, Sprech- oder Beratungsstunden sowie „Online- Führungen“, die mit Hilfe von Videokonferenz-Technologien umgesetzt werden können, und sammeln Erfahrungen in der praktischen Nutzung.</p> <p>Was werden wir tun?<br/>t.b.a. (nach dem ersten Treffen)</p> <p>EBmoocplus2020 –das Wichtigste für die digitale Praxis in der Erwachsenenbildung<br/>Ein kostenloser Onlinekurs für Erwachsenenbildner/innen mit Austauschmöglichkeitin Foren, Webinaren und Begleitgruppen</p> <p>Kursinhalt und Ziele<br/>Teilnehmer/innen erwerben Erfahrung und Knowhow über<br/>• Erwachsenenbildung im digitalen Zeitalter<br/>• Formate und Didaktik im digitalen Raum<br/>• Digitale Werkzeuge für die Erwachsenenbildungs-Praxis<br/>• Sicherheit und Datenschutz in der Erwachsenenbildung•Soziale Lernumgebungen im digitalen Raum<br/>• Kritische Medienkompetenz und Erwachsenenbildung•Offene Bildungsressourcen<br/>• Webinare und Live-Videoformate für die Erwachsenenbildung<br/>• Möglichkeiten zum Weiterlernen</p> <p>Ablauf:<br/>• 8 Module in 8 Wochen ab 4. März 2020 (Workload je 3-4 Stunden) + Abschlussmodul (2 Stunden)<br/>• Es wird wöchentlich jeweils ein Modul freigeschaltet.<br/>• Jede Einheit besteht aus einem einführenden Video, ergänzenden Arbeitsmaterialien, einerAufgabenstellung dazu und einem kleinen Test zur (Selbst-)Überprüfung.<br/>• Zusätzlich gibt es ein Forum zur Diskussion über die Kursthemen.<br/>• Außerdem werden begleitend unterschiedliche Typen von Webinaren angeboten<br/>• Alle Materialien werden als Creative Commons Namensnennung 4.0 International Lizenz lizenziert und können auch nach Kursablauf weiter verwendet werden.</p> <p>Mehr Infos zum EBmoocplus2020 unter <a href="https://erwachsenenbildung.at/ebmooc" class="linkified">https://erwachsenenbildung.at/ebmooc</a></p> <p>Anmeldung zum EBmoocplus20202: <a href="https://imoox.at/mooc/local/courseintro/views/startpage.php?id=77" class="linkified">https://imoox.at/mooc/local/courseintro/views/startpage.php?id=77</a></p> <p>EBmooc plus erwachsenenbildung.at 2020<br/>CC BY 4.0 CONEDU #ebmoocplus20<br/>Gefördert aus Mitteln des Bundesministeriums für Bildung, Wissenschaft und Forschung</p> ',
      how_to_find_us: '',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1582987883000,
      duration: 3600000,
      id: '15',
      name: 'Begleitgruppe der edulabs zum EBmoocplus2020 8. Treffen',
      rsvp_limit: 15,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1588606200000,
      local_date: '2020-05-04',
      local_time: '17:30',
      updated: 1582987883000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 1,
      venue: {
        id: 16,
        name: 'WikiMUC Wikipedia',
        lat: 48.13136291503906,
        lon: 11.57040786743164,
        repinned: true,
        address_1: 'Angertorstraße 3',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1529326085000,
        name: 'edulabs München',
        id: 17,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'edulabs-Munchen',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/edulabs-Munchen/events/269086400/',
      description: '<p>Die edulabs München bieten zum EBmoocplus2020 eine Begleitgruppe an. Wir treffen dazu in den Räumen von Wikipedia in München oder im Café Netzwerk des KJR München.</p> <p>Inhalt des 9. Moduls:<br/>Die Teilnehmenden erfahren im Abschlussmodul alles über die Anerkennungs- und Verwertungsmöglichkeiten des EBmooc und über seine Nutzungsmöglichkeiten bis Ende 2020. Sie nehmen an der Kursevaluation teil. Weiters erhalten sie Anregungen für eine künftige Teilnahme an digitalen Lern-Netzen und für die weitere digitale Professionalisierung. Erfolgreiche AbsolventInnen können ihr Zertifikat und ihre digitalen Lernabzeichen (Badges) für die Teilnahme am EBmooc abrufen.</p> <p>Was werden wir tun?<br/>Abschlussrunde und Option des Weiterlernens und Arbeitens ergründen.</p> <p>EBmoocplus2020 –das Wichtigste für die digitale Praxis in der Erwachsenenbildung<br/>Ein kostenloser Onlinekurs für Erwachsenenbildner/innen mit Austauschmöglichkeitin Foren, Webinaren und Begleitgruppen</p> <p>Kursinhalt und Ziele<br/>Teilnehmer/innen erwerben Erfahrung und Knowhow über<br/>• Erwachsenenbildung im digitalen Zeitalter<br/>• Formate und Didaktik im digitalen Raum<br/>• Digitale Werkzeuge für die Erwachsenenbildungs-Praxis<br/>• Sicherheit und Datenschutz in der Erwachsenenbildung•Soziale Lernumgebungen im digitalen Raum<br/>• Kritische Medienkompetenz und Erwachsenenbildung•Offene Bildungsressourcen<br/>• Webinare und Live-Videoformate für die Erwachsenenbildung<br/>• Möglichkeiten zum Weiterlernen</p> <p>Ablauf:<br/>• 8 Module in 8 Wochen ab 4. März 2020 (Workload je 3-4 Stunden) + Abschlussmodul (2 Stunden)<br/>• Es wird wöchentlich jeweils ein Modul freigeschaltet.<br/>• Jede Einheit besteht aus einem einführenden Video, ergänzenden Arbeitsmaterialien, einerAufgabenstellung dazu und einem kleinen Test zur (Selbst-)Überprüfung.<br/>• Zusätzlich gibt es ein Forum zur Diskussion über die Kursthemen.<br/>• Außerdem werden begleitend unterschiedliche Typen von Webinaren angeboten<br/>• Alle Materialien werden als Creative Commons Namensnennung 4.0 International Lizenz lizenziert und können auch nach Kursablauf weiter verwendet werden.</p> <p>Mehr Infos zum EBmoocplus2020 unter <a href="https://erwachsenenbildung.at/ebmooc" class="linkified">https://erwachsenenbildung.at/ebmooc</a></p> <p>Anmeldung zum EBmoocplus20202: <a href="https://imoox.at/mooc/local/courseintro/views/startpage.php?id=77" class="linkified">https://imoox.at/mooc/local/courseintro/views/startpage.php?id=77</a></p> <p>EBmooc plus erwachsenenbildung.at 2020<br/>CC BY 4.0 CONEDU #ebmoocplus20<br/>Gefördert aus Mitteln des Bundesministeriums für Bildung, Wissenschaft und Forschung</p> ',
      how_to_find_us: '',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1584095149000,
      duration: 7200000,
      id: '18',
      name: 'ONLINE-Event: Dokumentarfilm LIVESTREAM+ Meditation+ Filmgespräch m. Regisseurin',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1586010600000,
      local_date: '2020-04-04',
      local_time: '16:30',
      updated: 1584456825000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 5,
      venue: {
        id: 19,
        name: 'https://pruffme.com/landing/u1359261/tmp1584302153',
        lat: 48.13119888305664,
        lon: 11.58899211883545,
        repinned: true,
        address_1: 'www',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1405527637000,
        name: 'Free ONLINE Meditation & Yoga – in Munich / München',
        id: 20,
        join_mode: 'approval',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Free-Meditation-Yoga-Munich',
        who: 'Meditators',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Free-Meditation-Yoga-Munich/events/269395204/',
      description: '<p>BEIDE KINO-EVENTS WERDEN ONLINE MIT LIVE STREAM DES DOKUMENTARFILMS STATTFINDEN !</p> <p>TERMINE:<br/>Sonntag 22. März, 12:00 Uhr (Matinee)<br/>Samstag 04. April, 16:30 Uhr</p> <p>Hier der Zugangslink zum Podcast Portal: <a href="https://pruffme.com/landing/u1359261/tmp1584302153" class="linkified">https://pruffme.com/landing/u1359261/tmp1584302153</a></p> <p>Sahaja Yoga Kultur e.V. präsentiert zum Anlass des 50. Jubiläumsjahrs von Sahaja Yoga, dem 97. Geburtstag der Gründerin Shri Mataji Nirmala Devi:</p> <p>Kino-Event "Nirmala Devi - Freedom &amp; Liberation" mit Dokumentarfilm, Meditation und Filmgespräch mit der Regisseurin Carolin Dassel</p> <p>Euer Team von Free Meditation &amp; Yoga</p> <p>Für ein interaktives online Filmgespräch mit Carolin Dassel bitte nur Google Chrome verwenden, user im Portal anlegen und Emailadresse 1h vor Eventbeginn an [masked] schicken, dann können wir Euch im Portal als "Speaker" anlegen.</p> <p>Film Homepage &amp; Trailer: www.nirmaladevi-film.de<br/>www.meditationmuenchen.org</p> ',
      how_to_find_us: 'https://pruffme.com/landing/u1359261/tmp1584302153',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1582569078000,
      duration: 10800000,
      id: '21',
      name: 'The Filmmakers Event - Pitch & Screening',
      rsvp_limit: 40,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1585843200000,
      local_date: '2020-04-02',
      local_time: '18:00',
      updated: 1582569078000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 19,
      venue: {
        id: 22,
        name: 'KIM - Kino im Einstein e.V.',
        lat: 48.13553237915039,
        lon: 11.601046562194824,
        repinned: true,
        address_1: 'Einsteinstraße 42',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1414170061000,
        name: 'Munich Film & Video Making',
        id: 23,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'MunichFilmMaking',
        who: 'Filmmakers',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/MunichFilmMaking/events/268957004/',
      description: '<p>The Filmmakers event!</p> <p>Get ready to learn from the work of a few fellow filmmakers and cinematographers.</p> <p>After a little welcome drink and chit chat, we will project a few short movies that have been made in Munich by local Directors and Cinematographers.</p> <p>We will also have some short project pitch in between. So if you have a movie idea in development, raise your hand!</p> <p>Once the projections are finished, we can enjoy some food and drinks all together with some music.</p> <p>Get ready for the Filmmakers event!</p> <p>// DETAILED PROGRAM WILL BE RELEASED SOON</p> ',
      how_to_find_us: 'Follow the signs by going down the stairs, the Cinema is located on the left in the middle of the corridor.',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1582098170000,
      duration: 17940000,
      id: '24',
      name: 'Games Lounge',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1592067600000,
      local_date: '2020-06-13',
      local_time: '19:00',
      updated: 1582098170000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 2,
      venue: {
        id: 25,
        name: 'Werk 1 München',
        lat: 48.12443542480469,
        lon: 11.607304573059082,
        repinned: true,
        address_1: 'Grafinger Str. 6',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1393492592000,
        name: 'Games Lounge',
        id: 26,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Games-Lounge',
        who: 'Gamer',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Games-Lounge/events/268821290/',
      description: '<p>Games Lounge is a regular event of the Videospielkultur e.V. at the event space of Werk 1 München near Ostbahnhof.</p> <p>You can find Werk 1 here: <a href="https://www.werk1.com/wp-content/uploads/sites/2/2019/04/wegbeschreibung_werk1_maerz_2.pdf" class="linkified">https://www.werk1.com/wp-content/uploads/sites/2/2019/04/wegbeschreibung_werk1_maerz_2.pdf</a></p> <p>We meet on Saturdays twice per month to play videogames from our extensive archive of old and new games. There are always different gaming stations available with something for everyone.</p> <p>There is no entry fee and free non-alcoholic drinks are available.</p> <p>If you haven\'t been to Games Lounge before you can find some impressions here: <a href="https://www.facebook.com/groups/videospielkultur/photos/" class="linkified">https://www.facebook.com/groups/videospielkultur/photos/</a></p> ',
      how_to_find_us: 'https://www.werk1.com/wp-content/uploads/sites/2/2019/04/wegbeschreibung_werk1_maerz_2.pdf',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1582987511000,
      duration: 5400000,
      id: '27',
      name: 'Begleitgruppe der edulabs zum EBmoocplus2020 6. Treffen',
      rsvp_limit: 15,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1587396600000,
      local_date: '2020-04-20',
      local_time: '17:30',
      updated: 1582987542000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 1,
      venue: {
        id: 28,
        name: 'WikiMUC Wikipedia',
        lat: 48.13136291503906,
        lon: 11.57040786743164,
        repinned: true,
        address_1: 'Angertorstraße 3',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1529326085000,
        name: 'edulabs München',
        id: 29,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'edulabs-Munchen',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/edulabs-Munchen/events/269086330/',
      description: '<p>Die edulabs München bieten zum EBmoocplus2020 eine Begleitgruppe an. Wir treffen dazu in den Räumen von Wikipedia in München oder im Café Netzwerk des KJR München.</p> <p>Inhalt des 7. Moduls:<br/>Die Teilnehmenden bekommen Einblick in Theorie und Praxis von Offenen Bildungsressourcen für ihre erwachsenenbildnerische Tätigkeit. Sie lernen dabei, wie sie Ressourcen für die Erwachsenenbildung finden und korrekt verwenden, und erproben das in der Praxis. Die Produktion und Lizenzierung von Offenen Bildungsressourcen werden als Vertiefungsthemen angeboten.</p> <p>Was werden wir tun?<br/>t.b.a. (nach dem ersten Treffen)</p> <p>EBmoocplus2020 –das Wichtigste für die digitale Praxis in der Erwachsenenbildung<br/>Ein kostenloser Onlinekurs für Erwachsenenbildner/innen mit Austauschmöglichkeitin Foren, Webinaren und Begleitgruppen</p> <p>Kursinhalt und Ziele<br/>Teilnehmer/innen erwerben Erfahrung und Knowhow über<br/>• Erwachsenenbildung im digitalen Zeitalter<br/>• Formate und Didaktik im digitalen Raum<br/>• Digitale Werkzeuge für die Erwachsenenbildungs-Praxis<br/>• Sicherheit und Datenschutz in der Erwachsenenbildung•Soziale Lernumgebungen im digitalen Raum<br/>• Kritische Medienkompetenz und Erwachsenenbildung•Offene Bildungsressourcen<br/>• Webinare und Live-Videoformate für die Erwachsenenbildung<br/>• Möglichkeiten zum Weiterlernen</p> <p>Ablauf:<br/>• 8 Module in 8 Wochen ab 4. März 2020 (Workload je 3-4 Stunden) + Abschlussmodul (2 Stunden)<br/>• Es wird wöchentlich jeweils ein Modul freigeschaltet.<br/>• Jede Einheit besteht aus einem einführenden Video, ergänzenden Arbeitsmaterialien, einerAufgabenstellung dazu und einem kleinen Test zur (Selbst-)Überprüfung.<br/>• Zusätzlich gibt es ein Forum zur Diskussion über die Kursthemen.<br/>• Außerdem werden begleitend unterschiedliche Typen von Webinaren angeboten<br/>• Alle Materialien werden als Creative Commons Namensnennung 4.0 International Lizenz lizenziert und können auch nach Kursablauf weiter verwendet werden.</p> <p>Mehr Infos zum EBmoocplus2020 unter <a href="https://erwachsenenbildung.at/ebmooc" class="linkified">https://erwachsenenbildung.at/ebmooc</a></p> <p>Anmeldung zum EBmoocplus20202: <a href="https://imoox.at/mooc/local/courseintro/views/startpage.php?id=77" class="linkified">https://imoox.at/mooc/local/courseintro/views/startpage.php?id=77</a></p> <p>EBmooc plus erwachsenenbildung.at 2020<br/>CC BY 4.0 CONEDU #ebmoocplus20<br/>Gefördert aus Mitteln des Bundesministeriums für Bildung, Wissenschaft und Forschung</p> ',
      how_to_find_us: '',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1574974376000,
      duration: 10800000,
      fee: {
        accepts: 'paypal',
        amount: 15,
        currency: 'EUR',
        description: '',
        label: 'Price',
        required: true
      },
      id: '30',
      name: 'Agile Game Night #39 - Daily Stand-up Game (ENGLISH game night) ',
      rsvp_limit: 15,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1587486600000,
      local_date: '2020-04-21',
      local_time: '18:30',
      updated: 1582197026000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 3,
      group: {
        created: 1471362725000,
        name: 'Agile Game Nights',
        id: 31,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Agile-Game-Night',
        who: 'Agile Gamer',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Agile-Game-Night/events/266812756/',
      description: '<p>Daily Stand-up Game</p> <p>The Daily Stand-up Game contains 5 cards, each identifying one dysfunction and the Scrum Master is the one who introduces them into the Daily Meeting, showing the card when one dysfunction is being identified. After the team learns the cards, the Scrum Master gives the cards to the Team members to frame each other when identifying any dysfunction.<br/>At Agile Game Nights we will present the reloaded version of the Game, introducing new cards and new rules.<br/>If interested, we can also play more games that help improve the Daily Meeting. These are small games: Active Listening Game - Last Word</p> <p>During a Daily Simulation each person provides his/her inputs. The next person who speaks needs to start his updates with the last word the previous colleague used. People need to pay great attention and focus on the updates. This is a funny game to practice with the Team to break the monotony of the daily Daily :).</p> <p>Their Website: <a href="https://www.agilecricket.com/daily-stand-up-game-1" class="linkified">https://www.agilecricket.com/daily-stand-up-game-1</a></p> <p>Some Background to the game facilitators:</p> <p>Raluca Mitan: "I am an agile coach, trainer, innovator and learner. I support organisations in their agile journeys and love to experiment with teams and managers to continually improve work and make customers happy. My current playground is Zeiss Digital Innovation Partners, where I help develop great products and support innovation and creativity, as well as cooking together and promoting our great music band."</p> <p>Rade Zivanovic: "Rade Zivanovic is an agilist who coaches organisations, teams, colleagues and friends, sometimes even family members and pets (when they tolerate it).<br/>He\'s been working in agile since 2010 and loves it. He worked in development teams at the beginning of his career, so he knows how it feels to be on the other side as well. He enjoys helping people and seeing them succeed."</p> <p>Happy Gaming<br/>Ellen und Sieglinde</p> <p>PS: Du hast auch ein tolles Spiel und möchtest uns das gern zeigen oder auch ausprobieren? Gastmoderatoren sind herzlich eingeladen. Sprich uns an.<br/>----------------------------<br/>Die Agile Game Night ist die Experimentierplattform für Business-Spiele</p> <p>Alle Übungen und Spiele können in Trainings, Workshops, aber auch Scrum-Retrospektiven oder anderen agilen Meetings genutzt werden, im Team neue Lösungsansätze zu entwickeln und Erfahrungen erlebbar zu machen. Unsere Game Night ist für jeden gedacht, der mehr über Agile Methoden erfahren und dabei Spaß haben und spielen möchte. Darüber hinaus können auch Trainer und Coaches davon profitieren, wie sie Spiele in ihre Seminare einbinden und diese vorab schon mal ausprobieren können.</p> <p>Spiele bilden metaphorisch reales Leben ab und helfen, Strukturen nicht nur theoretisch, sondern persönlich zu erleben, erfahren und verinnerlichen.</p> <p>Teilen Sie die Veranstaltung und laden Sie andere ein:</p> <p><a href="http://www.meetup.com/de-DE/Agile-Game-Night/" class="linkified">http://www.meetup.com/de-DE/Agile-Game-Night/</a><br/><a href="http://www.kiwi-COO-business-games.de" class="linkified">http://www.kiwi-COO-business-games.de</a><br/><a href="https://www.facebook.com/groups/agilegamenights/" class="linkified">https://www.facebook.com/groups/agilegamenights/</a></p> ',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1574173917000,
      duration: 7200000,
      id: '32',
      name: 'AfterWERK meets MUNICH STARTUP.de',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1587052800000,
      local_date: '2020-04-16',
      local_time: '18:00',
      updated: 1574173917000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 37,
      venue: {
        id: 33,
        name: 'Atelierstraße 29',
        lat: 48.12380599975586,
        lon: 11.608274459838867,
        repinned: true,
        address_1: 'Atelierstraße 29',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1458124246000,
        name: 'WERK1',
        id: 34,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'WERK1munich',
        who: 'movers and shakers',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/WERK1munich/events/266581302/',
      description: '<p>Once per month, the Munich Startup Community meets at WERK1 for the famous „Feierabend-Bier“, snacks and wine!</p> <p>Join us for 1-2 pitches &amp; networking. If you are interested in pitching yourself, write to [masked].</p> <p>In a nutshell<br/>– Thursday, 16th April 2020 || 6pm<br/>– Informal networking with snacks &amp; drinks<br/>– Meet Munich Entrepreneurs Startups &amp; Freelancers<br/>– max. 2 startup pitches, 4 minutes each</p> ',
      how_to_find_us: 'Access by car only via "Piusstraße", coming by S-Bahn Ostbahnhof enter Werksviertel on "Speicherstraße".',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1580226850000,
      duration: 7200000,
      id: '35',
      name: 'Video & Film Makers - Social',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1590080400000,
      local_date: '2020-05-21',
      local_time: '19:00',
      updated: 1584348447000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 28,
      venue: {
        id: 36,
        name: 'Hofbräukeller',
        lat: 48.13409423828125,
        lon: 11.595478057861328,
        repinned: true,
        address_1: 'Innere Wiener Straße 19',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1414170061000,
        name: 'Munich Film & Video Making',
        id: 37,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'MunichFilmMaking',
        who: 'Filmmakers',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/MunichFilmMaking/events/268267658/',
      description: '<p>//// DATE CHANGED ---&gt; 21rst MAY ///////<br/>The social gathering is pushed back in order to help the confinement of the coronavirus.</p> <p>Dear Video enthusiasts,</p> <p>Videos are booming!</p> <p>Branding, animations, educational, documentaries, tutorials, interviews, vlogs and many more video formats are getting accessible to everyone, not only on the consumption side, but also on the making!</p> <p>Do you have it in you to capture moments, tell stories or envision video ideas?</p> <p>This is the occasion to meet, learn and collaborate with videobuilders!</p> <p>This is a purely social event for networking. At first, we start by a round of table to get to know everybody and what they are interested with, and then we end up getting chitty chatty all over the place :)</p> <p>See yall there.</p> <p>• What to bring</p> <p>• Important to know</p> ',
      how_to_find_us: 'There will be a table reserved at the name Arty.',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1582098053000,
      duration: 17940000,
      id: '38',
      name: 'Games Lounge',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1587834000000,
      local_date: '2020-04-25',
      local_time: '19:00',
      updated: 1582098053000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 2,
      venue: {
        id: 39,
        name: 'Werk 1 München',
        lat: 48.12443542480469,
        lon: 11.607304573059082,
        repinned: true,
        address_1: 'Grafinger Str. 6',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1393492592000,
        name: 'Games Lounge',
        id: 40,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Games-Lounge',
        who: 'Gamer',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Games-Lounge/events/268821277/',
      description: '<p>Games Lounge is a regular event of the Videospielkultur e.V. at the event space of Werk 1 München near Ostbahnhof.</p> <p>You can find Werk 1 here: <a href="https://www.werk1.com/wp-content/uploads/sites/2/2019/04/wegbeschreibung_werk1_maerz_2.pdf" class="linkified">https://www.werk1.com/wp-content/uploads/sites/2/2019/04/wegbeschreibung_werk1_maerz_2.pdf</a></p> <p>We meet on Saturdays twice per month to play videogames from our extensive archive of old and new games. There are always different gaming stations available with something for everyone.</p> <p>There is no entry fee and free non-alcoholic drinks are available.</p> <p>If you haven\'t been to Games Lounge before you can find some impressions here: <a href="https://www.facebook.com/groups/videospielkultur/photos/" class="linkified">https://www.facebook.com/groups/videospielkultur/photos/</a></p> ',
      how_to_find_us: 'https://www.werk1.com/wp-content/uploads/sites/2/2019/04/wegbeschreibung_werk1_maerz_2.pdf',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1584316291000,
      duration: 5400000,
      id: '41',
      name: 'Young Generation - Free ONLINE Meditation',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1584988200000,
      local_date: '2020-03-23',
      local_time: '19:30',
      updated: 1584316291000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 8,
      venue: {
        id: 42,
        name: 'https://pruffme.com/landing/u1359261/tmp1584302153',
        lat: 48.13512420654297,
        lon: 11.58198070526123,
        repinned: true,
        address_1: 'www',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1405527637000,
        name: 'Free ONLINE Meditation & Yoga – in Munich / München',
        id: 43,
        join_mode: 'approval',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Free-Meditation-Yoga-Munich',
        who: 'Meditators',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Free-Meditation-Yoga-Munich/events/hbpsqrybcfbfc/',
      description: '<p>Free ONLINE Meditation class for BEGINNERS &amp; ADVANCED !</p> <p>A Global initiative to change the world by changing ourselves.</p> <p>Teilnahmelink: <a href="https://pruffme.com/landing/u1359261/tmp1584302153" class="linkified">https://pruffme.com/landing/u1359261/tmp1584302153</a></p> <p>Video: <a href="https://www.youtube.com/watch?v=DrCcHm_M16Y&amp;list=PL11600E36E6E9E4AC" class="embedded">https://www.youtube.com/watch?v=DrCcHm_M16Y&amp;list=PL11600E36E6E9E4AC</a></p> <p>CoolCheck-Website (<a href="http://coolcheck.org/" class="linkified">http://coolcheck.org/</a>)</p> <p>Life only gets better. You’re about to start an amazing journey.</p> <p>However, it is special because it has the power to completely and totally relax your mind and body while energizing it, leaving you in a state where you are able to do anything and everything.<br/>Now we get down to the technicalities. The first step to achieving a state of meditation is simply desire; you have to want it. For your first meditation, it is best to find a quiet place where you can sit comfortably. Take your shoes, glasses, or any extra items off; basically get ready to relax.<br/>Now you know the body is made of three channels and 7 energy centers. An imbalance in any of these is due to the life we lead. So the first thing we shall do is to cleanse these Centers.</p> <p>Info: mobile/whatsapp: [masked] (Ganesh)</p> ',
      how_to_find_us: 'https://pruffme.com/landing/u1359261/tmp1584302153',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1584034053000,
      duration: 5400000,
      id: '44',
      name: 'Casual Billiards (8/9/10 Ball) ',
      rsvp_limit: 10,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1585071000000,
      local_date: '2020-03-24',
      local_time: '18:30',
      updated: 1584034053000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 3,
      venue: {
        id: 45,
        name: 'Bavaria Billiards',
        lat: 48.15731430053711,
        lon: 11.536917686462402,
        repinned: false,
        address_1: 'Landshuter Allee 87',
        city: 'München ',
        country: 'DE',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1517771075000,
        name: 'Sports & Social Munich',
        id: 46,
        join_mode: 'approval',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Sports-Social-Munich',
        who: 'Members',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Sports-Social-Munich/events/cbhqqrybcfbgc/',
      description: '<p>This group is for people (of all skill levels) that want to play Billiards (8/9/10) ball. Currently we play at Bavaria Billiards, either in doubles or singles, depending on how many people join. The exact address is:</p> <p>Bavaria Billard Bar Gerhard Huber<br/>Landshuter Allee 87, 80637 München, Germany<br/><a href="https://maps.app.goo.gl/vemAHtjnaSfiKWAG8" class="linkified">https://maps.app.goo.gl/vemAHtjnaSfiKWAG8</a></p> <p>You should get there at the exact specified time, as the tables get full extremely quickly, and reserving it might not be possible depending on the interest. RSVP and we can hold a table for you. As we have to pay for the tables to reserve them, failure to show up twice will result in removal from the group. If the interest is much greater than the capacity, we\'ll switch to a different venue 😁</p> <p>The current venue also has an arcade. Cost should be between €8 to €10 per hour depending on how many people show up.</p> ',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1574174623000,
      duration: 7200000,
      id: '47',
      name: 'AfterWERK meets MUNICH STARTUP.de',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1589990400000,
      local_date: '2020-05-20',
      local_time: '18:00',
      updated: 1579073757000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 23,
      venue: {
        id: 48,
        name: 'Atelierstraße 29',
        lat: 48.12380599975586,
        lon: 11.608274459838867,
        repinned: true,
        address_1: 'Atelierstraße 29',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1458124246000,
        name: 'WERK1',
        id: 49,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'WERK1munich',
        who: 'movers and shakers',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/WERK1munich/events/266581534/',
      description: '<p>Once per month, the Munich Startup Community meets at WERK1 for the famous „Feierabend-Bier“, snacks and wine!</p> <p>Join us for 1-2 pitches &amp; networking. If you are interested in pitching yourself, write to [masked].</p> <p>In a nutshell<br/>– Thursday, 20th May 2020 || 6pm<br/>– Informal networking with snacks &amp; drinks<br/>– Meet Munich Entrepreneurs Startups &amp; Freelancers<br/>– max. 2 startup pitches, 4 minutes each</p> ',
      how_to_find_us: 'Access by car only via "Piusstraße", coming by S-Bahn Ostbahnhof enter Werksviertel on "Speicherstraße".',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1581290045000,
      duration: 25200000,
      fee: {
        accepts: 'cash',
        amount: 5,
        currency: 'EUR',
        description: '',
        label: 'Price',
        required: false
      },
      id: '50',
      name: 'POSTPONED - GOA Walks: Kraftwerk Baierbrunn – Georgenstein Loop',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1587283200000,
      local_date: '2020-04-19',
      local_time: '10:00',
      updated: 1584548825000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 6,
      venue: {
        id: 51,
        name: 'Buchenhain',
        lat: 48.03166580200195,
        lon: 11.497190475463867,
        repinned: true,
        city: 'Baierbrunn',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1447452736000,
        name: 'Great Outdoor Adventurers - DE',
        id: 52,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'DE01GOA',
        who: 'Adventurists',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/DE01GOA/events/268591423/',
      description: '<p>Join us for a day hike along the Isar river up towards Grünwald as we cross the river, we again make our way along Isar towards Georgenstein then along Romanstrasse up to the Roman ski jump before return back towards Grünwald.</p> <p>On the once exposed mountain plateau, just above the Georgenstein, there was once a late Roman guard station and later medieval fortifications. From here the river crossing was observed and protection was offered to the population. The huge, up to 10 meters high, multi-level ramparts date from the early Middle Ages. It is believed that the wooden castle built had to do with the Hungarian invasions that threatened the country around 899. The former fields and estates have given way to the forest.</p> <p>360 degree view of Georgenstein <a href="https://preview.tinyurl.com/wakekth" class="linkified">https://preview.tinyurl.com/wakekth</a></p> <p>Hiking Highlights</p> <p>Schöner Platz im Auwald<br/>Alter Holzweg<br/>Schöner Trail an der Isar<br/>Grünwalder Stauwehr<br/>Kraftwerk Baierbrunn<br/>Georgenstein<br/>Schöner Blick auf die Isar und in das Tal<br/>Holzpfade</p> <p>⏱ 4:15hrs Hiking (excluding stoppage time)<br/>↔️ 13.2Km<br/>↗️ 161m (total uphill)<br/>↘️ 162m (total downhill)<br/>🛆 A:619m/D:538m<br/>🥾Hike boots/Trainers<br/>🎚 Intermediate Level<br/>🐌 Pace 3.8Kph</p> <p>📍O-Route: <a href="https://www.outdooractive.com/en/r/127380816" class="linkified">https://www.outdooractive.com/en/r/127380816</a></p> <p>🚏Meeting Point: I will be waiting for everyone outside the main Buchenhain station entrance @ 10.40am</p> <p>✈️🚂️🚐 Transport: Depart: Munich Hfb - Arrive: Buchenhain Bahnhof 10.36am (return from Höllriegelskreuth to Munich)<br/>🚂️ DB Timetable: <a href="https://www.sbb.ch/en/timetable.html" class="linkified">https://www.sbb.ch/en/timetable.html</a></p> <p>🍽 ☕️ 🍻 Cafe/Restaurants: there are cafe/bars in Grünwald.</p> <p>🍎🍌🥪🍫🥤Food/Drinks: You are advised to bring a packed lunch and water (minimum 2L) for the hike.</p> <p>🎒🧥👖👕🧦 🥾👂📸🛌🔦 What You Need: <a href="https://drive.google.com/open?id=1tWEgt30VZUmkH0F9yHOk7qibubN0SOea" class="linkified">https://drive.google.com/open?id=1tWEgt30VZUmkH0F9yHOk7qibubN0SOea</a></p> <p>💶 💷 Payment: €5 Day hike fee. Pay via <a href="https://www.paypal.me/PASHAA/5" class="linkified">https://www.paypal.me/PASHAA/5</a> in Euros</p> <p>🌤Weather: It is generally dry in April but temperatures and conditions can vary alot.<br/>🌤 Local Weather: <a href="https://www.meteoblue.com/en/weather/14-days/grünwald_germany_[masked]" class="linkified">https://www.meteoblue.com/en/weather/14-days/grünwald_germany_[masked]</a></p> <p>📞 Should you need to contact me my number is [masked] (my mobile blocks any numbers which are masked, withheld or private) otherwise you can email at [masked]</p> <p>#GOA-DE #GOA-CH</p> ',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1581639659000,
      duration: 10800000,
      id: '53',
      name: 'Unternehmertreffen & Start up-Event in München',
      rsvp_limit: 30,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1591545600000,
      local_date: '2020-06-07',
      local_time: '18:00',
      updated: 1582394104000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 3,
      venue: {
        id: 54,
        name: 'The Flushing Meadows Bar, Frauenhoferstraße 32, 80469 München',
        lat: 48.128822326660156,
        lon: 11.574684143066406,
        repinned: false,
        address_1: ' Frauenhoferstraße 32, 80469 München',
        city: 'München',
        country: 'DE',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1581635431000,
        name: 'Unternehmertreffen and Start up-Event "München"',
        id: 55,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Unternehmertreffen-Start-up-Event-Munchen',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Unternehmertreffen-Start-up-Event-Munchen/events/268694942/',
      description: '<p>DAS UNTERNEHMERTREFFEN „MÜNCHEN“ STARTUP EVENT</p> <p>INVESTOREN / BUSINESS-ANGEL*<br/>*mehr Details in der Beschreibung</p> <p>Das Unternehmertreffen Munich-Milan ist das Forum für Geschäftsfreunde in ganz Deutschland. Wir hören gemeinsam spannende Vorträge, veranstalten Aktionen, haben Zeit für informelle Gespräche und bahnen Geschäfte an.</p> <p>Wir sind überparteilich und unabhängig. Und vor allem: Wir haben viel Spaß am Netzwerken!</p> <p>Zahlreiche UNTERNEHMER und STARTUP UNTERNEHMEN aus dem Raum München nehmen teil und freuen sich über Jeden, der unser Netzwerk weiter verstärkt. AUCH STUDENTEN MIT GUTEN IDEEN SIND HERZLICH WILLKOMMEN.</p> <p>Informationen und Tickets finden sich unter: <a href="https://www.munich-milan.de/cms/de/unternehmertreffen-muenchen-3" class="linkified">https://www.munich-milan.de/cms/de/unternehmertreffen-muenchen-3</a></p> <p>Gerne auch per Telefon: Christian Lenk +49 (0)[masked]</p> <p>Ablauf:<br/>Begrüßung<br/>Kurze Vorstellungsrunde:<br/>- Name, Alter, Herkunft<br/>- Aktuelle Geschäftsbereiche und Projekte</p> <p>Anschließend dürfen 2 freiwillige Unternehmer ihre Geschäfte/ Projekte der Gruppe vorstellen, jeweils circa 15 Minuten.</p> <p>Nach jeder Runde wird eine Unterstützerrunde (Nutzung der Schwarmintelligenz) eingeleitet, wo die Anwesenden für das vorgestellte Projekt zB.:<br/>- Helfende Kontakte zusprechen können<br/>- Ideen zur Förderung des Geschäfts einbringen dürfen<br/>- Selbst Interesse äußern können, um neue Geschäftsbeziehungen anzubahnen.</p> <p>Wenn du einen interessanten Partner kennengelernt hast, könnt ihr eure Visitenkarten austauschen. Diese Runde ist ebenfalls mit 15 Minuten angesetzt.</p> <p>Abschließend wird das Treffen mit einem Referenten aus dem Forex Markt oder Krypto Bereich abgerundet und offen ausgetauscht.</p> <p>Dein Mehrwert<br/>Du lernst jeden Teilnehmer persönlich kennen, wodurch dein Netzwerk sehr schnell wächst. Durch neue Geschäftskontakte und den sich daraus ergebenden Möglichkeiten, kannst du große Umsatzsteigerungen erzielen. Du lernst regionale Geschäftspartner kennen, die, wie auch du, etwas erreichen und schaffen wollen. Gemeinsam könnt ihr eure Ideen schneller und einfacher umsetzen.</p> <p>Informelle Gespräche<br/>Nach dem offiziellen Teil des Unternehmertreffens, in dessen Mittelpunkt die Nutzung der Schwarmintelligenz für die vorgestellten Projekte steht, geht es mit lockerem Netzwerken und viel informellem Austausch weiter. So entstehen echte Geschäftsfreundschaften.</p> <p>Netzwerken<br/>Netzwerke bilden heute die Basis für viele unternehmerische Aktivitäten. Genau dies ist der Grundgedanke von Munich-Milan Wir machen miteinander Geschäfte, unterstützen uns gegenseitig – und haben auch eine Menge Spaß.</p> <p>Melde dich jetzt für Sonntag an und wir sehen uns beim Unternehmertreffen!<br/>Anmelden ist Pflicht: Nach vielen Nachfragen noch der Gästelistelink:<br/><a href="https://www.munich-milan.de/cms/de/unternehmertreffen-muenchen-3" class="linkified">https://www.munich-milan.de/cms/de/unternehmertreffen-muenchen-3</a></p> <p>Nur wer die Reservierung für 20,00 Euro bestätigt kann kommen.</p> <p>An der Tür "The Flushing Meadows Bar, Frauenhoferstraße 32, 80469 München" bitte die Bestätigung vorzeigen:</p> <p>OHNE TICKET KEIN EINLASS!<br/>Wir freuen uns auf dich und deine Idee</p> <p>INFO INVESTOREN - BUSINESSANGEL:<br/>Wir laden regelmäßig Investoren ein, die sich neue Startup Ideen anschauen. Ein Investor stellt sich nie als Investor vor. Er wird mit dir Kontakt aufnehmen, sollte deine Idee interessant sein!</p> ',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1574974419000,
      duration: 10800000,
      fee: {
        accepts: 'paypal',
        amount: 15,
        currency: 'EUR',
        description: '',
        label: 'Price',
        required: true
      },
      id: '56',
      name: 'Agile Game Night #40 - Agile Fluency Game',
      rsvp_limit: 15,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1589473800000,
      local_date: '2020-05-14',
      local_time: '18:30',
      updated: 1583918231000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 2,
      group: {
        created: 1471362725000,
        name: 'Agile Game Nights',
        id: 57,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Agile-Game-Night',
        who: 'Agile Gamer',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Agile-Game-Night/events/266812858/',
      description: '<p>Save the Date! Florian Halmburger und weitere Spielleiter werden uns das Agile Fluency Game vorstellen.<br/>Für die Agile Game Night<br/>– Die Beschreibung zum Spiel / der Simulation / dem Thema kommt in Kürze...</p> <p>Das hier sind schon mal die vorläufigen Termine für die zweite Jahreshälfte:<br/>Q3: DO,[masked] + DI,[masked] - DO,[masked]<br/>Q4: DI,[masked] + DO,[masked] + DI,[masked]</p> <p>Du hast ein tolles Spiel und möchtest uns das gern zeigen oder auch ein neues ausprobieren? Gastmoderatoren sind herzlich eingeladen. Sprich uns an.</p> <p>Happy Gaming<br/>Ellen und Sieglinde</p> <p>PS: Du hast auch ein tolles Spiel und möchtest uns das gern zeigen oder auch ausprobieren? Gastmoderatoren sind herzlich eingeladen. Sprich uns an.<br/>----------------------------<br/>Die Agile Game Night ist die Experimentierplattform für Business-Spiele</p> <p>Alle Übungen und Spiele können in Trainings, Workshops, aber auch Scrum-Retrospektiven oder anderen agilen Meetings genutzt werden, im Team neue Lösungsansätze zu entwickeln und Erfahrungen erlebbar zu machen. Unsere Game Night ist für jeden gedacht, der mehr über Agile Methoden erfahren und dabei Spaß haben und spielen möchte. Darüber hinaus können auch Trainer und Coaches davon profitieren, wie sie Spiele in ihre Seminare einbinden und diese vorab schon mal ausprobieren können.</p> <p>Spiele bilden metaphorisch reales Leben ab und helfen, Strukturen nicht nur theoretisch, sondern persönlich zu erleben, erfahren und verinnerlichen.</p> <p>Teilen Sie die Veranstaltung und laden Sie andere ein:</p> <p><a href="http://www.meetup.com/de-DE/Agile-Game-Night/" class="linkified">http://www.meetup.com/de-DE/Agile-Game-Night/</a><br/><a href="http://www.kiwi-COO-business-games.de" class="linkified">http://www.kiwi-COO-business-games.de</a><br/><a href="https://www.facebook.com/groups/agilegamenights/" class="linkified">https://www.facebook.com/groups/agilegamenights/</a></p> ',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1582098084000,
      duration: 17940000,
      id: '58',
      name: 'Games Lounge',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1589648400000,
      local_date: '2020-05-16',
      local_time: '19:00',
      updated: 1582098084000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 2,
      venue: {
        id: 59,
        name: 'Werk 1 München',
        lat: 48.12443542480469,
        lon: 11.607304573059082,
        repinned: true,
        address_1: 'Grafinger Str. 6',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1393492592000,
        name: 'Games Lounge',
        id: 60,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Games-Lounge',
        who: 'Gamer',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Games-Lounge/events/268821281/',
      description: '<p>Games Lounge is a regular event of the Videospielkultur e.V. at the event space of Werk 1 München near Ostbahnhof.</p> <p>You can find Werk 1 here: <a href=\'https://www.werk1.com/wp-content/uploads/sites/2/2019/04/wegbeschreibung_werk1_maerz_2.pdf\' class=\'linkified\'>https://www.werk1.com/wp-content/uploads/sites/2/2019/04/wegbeschreibung_werk1_maerz_2.pdf</a></p> <p>We meet on Saturdays twice per month to play videogames from our extensive archive of old and new games. There are always different gaming stations available with something for everyone.</p> <p>There is no entry fee and free non-alcoholic drinks are available.</p> <p>If you haven\'t been to Games Lounge before you can find some impressions here: <a href=\'https://www.facebook.com/groups/videospielkultur/photos/\' class=\'linkified\'>https://www.facebook.com/groups/videospielkultur/photos/</a></p> ',
      how_to_find_us: 'https://www.werk1.com/wp-content/uploads/sites/2/2019/04/wegbeschreibung_werk1_maerz_2.pdf',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1585225675000,
      duration: 349200000,
      id: '61',
      name: '5 Tage Business Durchstarter Online Programm',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1585549800000,
      local_date: '2020-03-30',
      local_time: '08:30',
      updated: 1585225675000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 2,
      group: {
        created: 1576235792000,
        name: 'Selbstbewusst, authentisch und leicht!',
        id: 62,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Selbstbewusst-authentisch-und-leicht-leben',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Selbstbewusst-authentisch-und-leicht-leben/events/269665397/',
      description: '<p>5 Tage<br/>5 Sessions<br/>5 x Inspiration</p> <p>In diesen 5 Tagen richtest Du Dein Business auf Erfolg aus.<br/>Du möchtest die Zeit während dieser Phase intensiv für Dein Business nutzen?<br/>Du möchtest endlich mehr Klarheit über Deine Strategie?</p> <p>In diesen 5 Tagen bekommst Du jeden Morgen in einer Live Online Session Input zu verschiedenen Themen wie Dein USP; Deine Vision, Deine Umsätze, Deine Produkte und Preise und im Anschluss erarbeitest Du individuell mit den von mir vorgestellten Materialien alles auf Dein Business abgestimmt.</p> <p>Wenn Du mal eine Session verpasst ist das gar nicht schlimm, Du bekommst im Anschluss die Aufzeichnungen zugeschickt und kannst Dir das auch später anschauen. Per E-Mail kannst DU Deine Fragen stellen und am Ende der Woche im Live Q&amp;A beantworte ich diese auch direkt persönlich.</p> <p>Diese Woche ist für Dich passend, wenn Du: neu mit Deinem Business starten möchtest, gerade nicht weisst, ob Du so wie es derzeit läuft auch weiter machen kannst, Du jetzt aufgrund der Corona Krise Deine Idee ausarbeiten möchtest oder auch um zu schauen, wo Du noch Potentiale hast, die Du noch gar nicht nutzt um zukünftig mehr Umsätze zu machen.</p> <p>Die Sessions finden per ZOOM statt. Den Link bekommst Du nach der Anmeldung.</p> <p>Anmelden kannst Du Dich direkt hier: <a href=\'https://www.digistore24.com/product/314695\' class=\'linkified\'>https://www.digistore24.com/product/314695</a></p> <p>Ich freue mich auf Dich!</p> <p>Deine Yvonne</p> ',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1582987679000,
      duration: 5400000,
      id: '63',
      name: 'Begleitgruppe der edulabs zum EBmoocplus2020 7. Treffen',
      rsvp_limit: 15,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1588001400000,
      local_date: '2020-04-27',
      local_time: '17:30',
      updated: 1582987679000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 1,
      venue: {
        id: 64,
        name: 'WikiMUC Wikipedia',
        lat: 48.13136291503906,
        lon: 11.57040786743164,
        repinned: true,
        address_1: 'Angertorstraße 3',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1529326085000,
        name: 'edulabs München',
        id: 65,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'edulabs-Munchen',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/edulabs-Munchen/events/269086368/',
      description: '<p>Die edulabs München bieten zum EBmoocplus2020 eine Begleitgruppe an. Wir treffen dazu in den Räumen von Wikipedia in München oder im Café Netzwerk des KJR München.</p> <p>Inhalt des 8. Moduls:<br/>In diesem Modul lernen ErwachsenenbildnerInnen einfache Webinar- und Videokonferenz-Technologien für den Einsatz in der Erwachsenenbildung kennen. Sie erfahren dabei Grundlegendes über Formate wie Online-Podiumsdiskussionen, Online- Gesprächsrunden, Sprech- oder Beratungsstunden sowie „Online- Führungen“, die mit Hilfe von Videokonferenz-Technologien umgesetzt werden können, und sammeln Erfahrungen in der praktischen Nutzung.</p> <p>Was werden wir tun?<br/>t.b.a. (nach dem ersten Treffen)</p> <p>EBmoocplus2020 –das Wichtigste für die digitale Praxis in der Erwachsenenbildung<br/>Ein kostenloser Onlinekurs für Erwachsenenbildner/innen mit Austauschmöglichkeitin Foren, Webinaren und Begleitgruppen</p> <p>Kursinhalt und Ziele<br/>Teilnehmer/innen erwerben Erfahrung und Knowhow über<br/>• Erwachsenenbildung im digitalen Zeitalter<br/>• Formate und Didaktik im digitalen Raum<br/>• Digitale Werkzeuge für die Erwachsenenbildungs-Praxis<br/>• Sicherheit und Datenschutz in der Erwachsenenbildung•Soziale Lernumgebungen im digitalen Raum<br/>• Kritische Medienkompetenz und Erwachsenenbildung•Offene Bildungsressourcen<br/>• Webinare und Live-Videoformate für die Erwachsenenbildung<br/>• Möglichkeiten zum Weiterlernen</p> <p>Ablauf:<br/>• 8 Module in 8 Wochen ab 4. März 2020 (Workload je 3-4 Stunden) + Abschlussmodul (2 Stunden)<br/>• Es wird wöchentlich jeweils ein Modul freigeschaltet.<br/>• Jede Einheit besteht aus einem einführenden Video, ergänzenden Arbeitsmaterialien, einerAufgabenstellung dazu und einem kleinen Test zur (Selbst-)Überprüfung.<br/>• Zusätzlich gibt es ein Forum zur Diskussion über die Kursthemen.<br/>• Außerdem werden begleitend unterschiedliche Typen von Webinaren angeboten<br/>• Alle Materialien werden als Creative Commons Namensnennung 4.0 International Lizenz lizenziert und können auch nach Kursablauf weiter verwendet werden.</p> <p>Mehr Infos zum EBmoocplus2020 unter <a href=\'https://erwachsenenbildung.at/ebmooc\' class=\'linkified\'>https://erwachsenenbildung.at/ebmooc</a></p> <p>Anmeldung zum EBmoocplus20202: <a href=\'https://imoox.at/mooc/local/courseintro/views/startpage.php?id=77\' class=\'linkified\'>https://imoox.at/mooc/local/courseintro/views/startpage.php?id=77</a></p> <p>EBmooc plus erwachsenenbildung.at 2020<br/>CC BY 4.0 CONEDU #ebmoocplus20<br/>Gefördert aus Mitteln des Bundesministeriums für Bildung, Wissenschaft und Forschung</p> ',
      how_to_find_us: '',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1584859310000,
      duration: 3600000,
      id: '66',
      name: 'Outdoor Training [Natural Movement]',
      rsvp_limit: 5,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1585675800000,
      local_date: '2020-03-31',
      local_time: '19:30',
      rsvp_close_offset: 'PT3H',
      updated: 1584859310000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 1,
      venue: {
        id: 67,
        name: 'Westpark',
        lat: 48.12034225463867,
        lon: 11.511041641235352,
        repinned: true,
        address_1: 'Specklinplatz',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1551533080000,
        name: 'MovNat München [Natural Movement Fitness]',
        id: 68,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'MovNat-Munchen-Natural-Movement-Fitness',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/MovNat-Munchen-Natural-Movement-Fitness/events/gmqxqrybcfbpc/',
      description: '<p>AUFGRUND DER AKTUELLEN SITUATION BIETEN WIR STATT UNSEREN REGULÄREN OUTDOOR TRAININGS EIN KOSTENLOSES ONLINE TRAINING AN:<br/><a href=\'https://movnatmuenchen.thinkific.com/\' class=\'linkified\'>https://movnatmuenchen.thinkific.com/</a><br/>---------------------------------------------------------------------------------------------------------------- Bleibt gesund! ------------------------------------------------------------</p> <p>Unser Dienstagstraining im Westpark</p> <p>Zweite Trainingseinheit 19:30 bis 20:30 Uhr</p> <p>Ein Probetraining ist kostenlos. Bitte kontaktiere uns auf jeden Fall vorher bis spätestens 16:30 Uhr am gleichen Tag per E-Mail wenn du kommen möchtest falls es einen spontanen Wechsel des Treffpunkts gibt.</p> <p>Wir freuen uns auf dich!</p> <p>Alle weiteren Trainings:<br/>5er-Karte: 70,-€ / 10er-Karte: 120,-€<br/>3-Monatskarte: 70,-€/Monat<br/>6- Monatskarte: 60,-€/Monat</p> <p><a href=\'http://www.movnatmuenchen.de\' class=\'linkified\'>http://www.movnatmuenchen.de</a> --- [masked]</p> ',
      how_to_find_us: 'Schreibe uns für den genauen Treffpunkt',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1583965221000,
      duration: 3600000,
      id: '69',
      name: 'The Purpose of Life in Buddhism',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1585569600000,
      local_date: '2020-03-30',
      local_time: '14:00',
      updated: 1583965221000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 3,
      group: {
        created: 1449538782000,
        name: 'München Meanings of Life in Buddhism Meetup',
        id: 70,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Munchen-Meanings-of-Life-in-Buddhism-Meetup',
        who: 'Members',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Munchen-Meanings-of-Life-in-Buddhism-Meetup/events/269359487/',
      description: '<p>Why were we born?<br/>Why are we living?<br/>What is the purpose of our life?<br/>What determines a good fate of happiness, or a bad fate of misfortune?<br/>We will have a Skype session to learn how Buddhism answers to these questions.<br/>If you want to join us, please send your Skype ID to \'davidguya25\' or by clicking this link: <a href=\'https://join.skype.com/IKHXhZqV1jLo\' class=\'linkified\'>https://join.skype.com/IKHXhZqV1jLo</a><br/>We also have our whatsapp group: <a href=\'https://chat.whatsapp.com/DnBijHRH4pTFQ7W5ymyPLI\' class=\'linkified\'>https://chat.whatsapp.com/DnBijHRH4pTFQ7W5ymyPLI</a><br/>If any questions, please contact [masked]<br/>The session will be shared only via Skype.</p> ',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1582987511000,
      duration: 5400000,
      id: '71',
      name: 'Begleitgruppe der edulabs zum EBmoocplus2020 6. Treffen',
      rsvp_limit: 15,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1587396600000,
      local_date: '2020-04-20',
      local_time: '17:30',
      updated: 1582987542000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 1,
      venue: {
        id: 72,
        name: 'WikiMUC Wikipedia',
        lat: 48.13136291503906,
        lon: 11.57040786743164,
        repinned: true,
        address_1: 'Angertorstraße 3',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1529326085000,
        name: 'edulabs München',
        id: 73,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'edulabs-Munchen',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/edulabs-Munchen/events/269086330/',
      description: '<p>Die edulabs München bieten zum EBmoocplus2020 eine Begleitgruppe an. Wir treffen dazu in den Räumen von Wikipedia in München oder im Café Netzwerk des KJR München.</p> <p>Inhalt des 7. Moduls:<br/>Die Teilnehmenden bekommen Einblick in Theorie und Praxis von Offenen Bildungsressourcen für ihre erwachsenenbildnerische Tätigkeit. Sie lernen dabei, wie sie Ressourcen für die Erwachsenenbildung finden und korrekt verwenden, und erproben das in der Praxis. Die Produktion und Lizenzierung von Offenen Bildungsressourcen werden als Vertiefungsthemen angeboten.</p> <p>Was werden wir tun?<br/>t.b.a. (nach dem ersten Treffen)</p> <p>EBmoocplus2020 –das Wichtigste für die digitale Praxis in der Erwachsenenbildung<br/>Ein kostenloser Onlinekurs für Erwachsenenbildner/innen mit Austauschmöglichkeitin Foren, Webinaren und Begleitgruppen</p> <p>Kursinhalt und Ziele<br/>Teilnehmer/innen erwerben Erfahrung und Knowhow über<br/>• Erwachsenenbildung im digitalen Zeitalter<br/>• Formate und Didaktik im digitalen Raum<br/>• Digitale Werkzeuge für die Erwachsenenbildungs-Praxis<br/>• Sicherheit und Datenschutz in der Erwachsenenbildung•Soziale Lernumgebungen im digitalen Raum<br/>• Kritische Medienkompetenz und Erwachsenenbildung•Offene Bildungsressourcen<br/>• Webinare und Live-Videoformate für die Erwachsenenbildung<br/>• Möglichkeiten zum Weiterlernen</p> <p>Ablauf:<br/>• 8 Module in 8 Wochen ab 4. März 2020 (Workload je 3-4 Stunden) + Abschlussmodul (2 Stunden)<br/>• Es wird wöchentlich jeweils ein Modul freigeschaltet.<br/>• Jede Einheit besteht aus einem einführenden Video, ergänzenden Arbeitsmaterialien, einerAufgabenstellung dazu und einem kleinen Test zur (Selbst-)Überprüfung.<br/>• Zusätzlich gibt es ein Forum zur Diskussion über die Kursthemen.<br/>• Außerdem werden begleitend unterschiedliche Typen von Webinaren angeboten<br/>• Alle Materialien werden als Creative Commons Namensnennung 4.0 International Lizenz lizenziert und können auch nach Kursablauf weiter verwendet werden.</p> <p>Mehr Infos zum EBmoocplus2020 unter <a href=\'https://erwachsenenbildung.at/ebmooc\' class=\'linkified\'>https://erwachsenenbildung.at/ebmooc</a></p> <p>Anmeldung zum EBmoocplus20202: <a href=\'https://imoox.at/mooc/local/courseintro/views/startpage.php?id=77\' class=\'linkified\'>https://imoox.at/mooc/local/courseintro/views/startpage.php?id=77</a></p> <p>EBmooc plus erwachsenenbildung.at 2020<br/>CC BY 4.0 CONEDU #ebmoocplus20<br/>Gefördert aus Mitteln des Bundesministeriums für Bildung, Wissenschaft und Forschung</p> ',
      how_to_find_us: '',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1574974376000,
      duration: 10800000,
      fee: {
        accepts: 'paypal',
        amount: 15,
        currency: 'EUR',
        description: '',
        label: 'Price',
        required: true
      },
      id: '74',
      name: 'Agile Game Night #39 - Daily Stand-up Game (ENGLISH game night) ',
      rsvp_limit: 15,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1587486600000,
      local_date: '2020-04-21',
      local_time: '18:30',
      updated: 1582197026000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 3,
      group: {
        created: 1471362725000,
        name: 'Agile Game Nights',
        id: 75,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Agile-Game-Night',
        who: 'Agile Gamer',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Agile-Game-Night/events/266812756/',
      description: '<p>Daily Stand-up Game</p> <p>The Daily Stand-up Game contains 5 cards, each identifying one dysfunction and the Scrum Master is the one who introduces them into the Daily Meeting, showing the card when one dysfunction is being identified. After the team learns the cards, the Scrum Master gives the cards to the Team members to frame each other when identifying any dysfunction.<br/>At Agile Game Nights we will present the reloaded version of the Game, introducing new cards and new rules.<br/>If interested, we can also play more games that help improve the Daily Meeting. These are small games: Active Listening Game - Last Word</p> <p>During a Daily Simulation each person provides his/her inputs. The next person who speaks needs to start his updates with the last word the previous colleague used. People need to pay great attention and focus on the updates. This is a funny game to practice with the Team to break the monotony of the daily Daily :).</p> <p>Their Website: <a href=\'https://www.agilecricket.com/daily-stand-up-game-1\' class=\'linkified\'>https://www.agilecricket.com/daily-stand-up-game-1</a></p> <p>Some Background to the game facilitators:</p> <p>Raluca Mitan: \'I am an agile coach, trainer, innovator and learner. I support organisations in their agile journeys and love to experiment with teams and managers to continually improve work and make customers happy. My current playground is Zeiss Digital Innovation Partners, where I help develop great products and support innovation and creativity, as well as cooking together and promoting our great music band.\'</p> <p>Rade Zivanovic: \'Rade Zivanovic is an agilist who coaches organisations, teams, colleagues and friends, sometimes even family members and pets (when they tolerate it).<br/>He\'s been working in agile since 2010 and loves it. He worked in development teams at the beginning of his career, so he knows how it feels to be on the other side as well. He enjoys helping people and seeing them succeed.\'</p> <p>Happy Gaming<br/>Ellen und Sieglinde</p> <p>PS: Du hast auch ein tolles Spiel und möchtest uns das gern zeigen oder auch ausprobieren? Gastmoderatoren sind herzlich eingeladen. Sprich uns an.<br/>----------------------------<br/>Die Agile Game Night ist die Experimentierplattform für Business-Spiele</p> <p>Alle Übungen und Spiele können in Trainings, Workshops, aber auch Scrum-Retrospektiven oder anderen agilen Meetings genutzt werden, im Team neue Lösungsansätze zu entwickeln und Erfahrungen erlebbar zu machen. Unsere Game Night ist für jeden gedacht, der mehr über Agile Methoden erfahren und dabei Spaß haben und spielen möchte. Darüber hinaus können auch Trainer und Coaches davon profitieren, wie sie Spiele in ihre Seminare einbinden und diese vorab schon mal ausprobieren können.</p> <p>Spiele bilden metaphorisch reales Leben ab und helfen, Strukturen nicht nur theoretisch, sondern persönlich zu erleben, erfahren und verinnerlichen.</p> <p>Teilen Sie die Veranstaltung und laden Sie andere ein:</p> <p><a href=\'http://www.meetup.com/de-DE/Agile-Game-Night/\' class=\'linkified\'>http://www.meetup.com/de-DE/Agile-Game-Night/</a><br/><a href=\'http://www.kiwi-COO-business-games.de\' class=\'linkified\'>http://www.kiwi-COO-business-games.de</a><br/><a href=\'https://www.facebook.com/groups/agilegamenights/\' class=\'linkified\'>https://www.facebook.com/groups/agilegamenights/</a></p> ',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1581065421000,
      duration: 143940000,
      id: '76',
      name: 'OUTDOOR COWORKING 2020',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1593151200000,
      local_date: '2020-06-26',
      local_time: '08:00',
      updated: 1581065462000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 1,
      group: {
        created: 1442238396000,
        name: 'OUTDOOR COWORKING',
        id: 77,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'outdoor-coworking-day',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/outdoor-coworking-day/events/268530677/',
      description: '<p>Coworking mal ganz woanders, aber doch im eigenen Van. Mit ganz wem anders, aber doch unter Freunden. Lüftet mit bekannten Unternehmen, Vanlifeworkern und spannenden Personen den Büroalltag mal ordentlich durch. 2019 waren von Firmen wie SIXT, ReCup, andere aus der Sport- oder Automotive-Branche, bis hin zu Agenturen, Freelancern, Fotografen und Influencern alles dabei.<br/>Wir laden Euch ein, Teil unseres #woooday in der Natur zu sein.</p> <p>Buchung unter: www.outdoor-coworking-day.de</p> ',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1574974457000,
      duration: 10800000,
      fee: {
        accepts: 'paypal',
        amount: 15,
        currency: 'EUR',
        description: '',
        label: 'Price',
        required: true
      },
      id: '78',
      name: 'Agile Game Night #41 - Lego Serious Play',
      rsvp_limit: 10,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1592929800000,
      local_date: '2020-06-23',
      local_time: '18:30',
      rsvp_close_offset: 'PT24H',
      updated: 1582196479000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 3,
      group: {
        created: 1471362725000,
        name: 'Agile Game Nights',
        id: 79,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Agile-Game-Night',
        who: 'Agile Gamer',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Agile-Game-Night/events/266812945/',
      description: '<p>Wir spielen wieder mal Lego Serious Play.<br/>Sybille Kuwert wird durch den Abend führen.<br/>Achtung: Max. 12 Teilnehmer.</p> <p>Wenn wir LEGO® Serious Play ® hören, denken wir an die LEGO Steine, mit denen wir so gerne als Kinder gespielt haben und fragen uns, was das im beruflichen Alltag zu suchen hat.</p> <p>Auch wenn die Steine von LEGO® Serious Play ®, denen aus unserer Kindheit ähneln, werden sie eingesetzt, um in einem kreativen Prozess, Wissen frei zu setzen, Denkmuster aufzubrechen und Kommunikation zu fokussieren.</p> <p>Wer LEGO® Serious Play ® kennen lernen und ausprobieren möchte, der sollte sich diesen Abend vormerken.<br/>Ihr werdet mit den Steinen verschiedene Aufgaben lösen und mit viel Spaß die verschiedenen Einsatzmöglichkeiten von LEGO® Serious Play ® erleben.</p> <p>Sybille Kuwert (certified LEGO® Serious Play ® facilitator) diskutiert mit Euch die Chancen und Grenzen der Methode.</p> <p>Die Anzahl der Teilnehmer ist auf 12 begrenzt.</p> <p>Happy Gaming<br/>Ellen und Sieglinde</p> <p>PS: Du hast auch ein tolles Spiel und möchtest uns das gern zeigen oder auch ausprobieren? Gastmoderatoren sind herzlich eingeladen. Sprich uns an.<br/>----------------------------<br/>Die Agile Game Night ist die Experimentierplattform für Business-Spiele</p> <p>Alle Übungen und Spiele können in Trainings, Workshops, aber auch Scrum-Retrospektiven oder anderen agilen Meetings genutzt werden, im Team neue Lösungsansätze zu entwickeln und Erfahrungen erlebbar zu machen. Unsere Game Night ist für jeden gedacht, der mehr über Agile Methoden erfahren und dabei Spaß haben und spielen möchte. Darüber hinaus können auch Trainer und Coaches davon profitieren, wie sie Spiele in ihre Seminare einbinden und diese vorab schon mal ausprobieren können.</p> <p>Spiele bilden metaphorisch reales Leben ab und helfen, Strukturen nicht nur theoretisch, sondern persönlich zu erleben, erfahren und verinnerlichen.</p> <p>Teilen Sie die Veranstaltung und laden Sie andere ein:</p> <p><a href=\'http://www.meetup.com/de-DE/Agile-Game-Night/\' class=\'linkified\'>http://www.meetup.com/de-DE/Agile-Game-Night/</a><br/><a href=\'http://www.kiwi-COO-business-games.de\' class=\'linkified\'>http://www.kiwi-COO-business-games.de</a><br/><a href=\'https://www.facebook.com/groups/agilegamenights/\' class=\'linkified\'>https://www.facebook.com/groups/agilegamenights/</a></p> ',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1580226850000,
      duration: 7200000,
      id: '80',
      name: 'Video & Film Makers - Social',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1590080400000,
      local_date: '2020-05-21',
      local_time: '19:00',
      updated: 1584348447000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 27,
      venue: {
        id: 81,
        name: 'Hofbräukeller',
        lat: 48.13409423828125,
        lon: 11.595478057861328,
        repinned: true,
        address_1: 'Innere Wiener Straße 19',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1414170061000,
        name: 'Munich Film & Video Making',
        id: 82,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'MunichFilmMaking',
        who: 'Filmmakers',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/MunichFilmMaking/events/268267658/',
      description: '<p>//// DATE CHANGED ---&gt; 21rst MAY ///////<br/>The social gathering is pushed back in order to help the confinement of the coronavirus.</p> <p>Dear Video enthusiasts,</p> <p>Videos are booming!</p> <p>Branding, animations, educational, documentaries, tutorials, interviews, vlogs and many more video formats are getting accessible to everyone, not only on the consumption side, but also on the making!</p> <p>Do you have it in you to capture moments, tell stories or envision video ideas?</p> <p>This is the occasion to meet, learn and collaborate with videobuilders!</p> <p>This is a purely social event for networking. At first, we start by a round of table to get to know everybody and what they are interested with, and then we end up getting chitty chatty all over the place :)</p> <p>See yall there.</p> <p>• What to bring</p> <p>• Important to know</p> ',
      how_to_find_us: 'There will be a table reserved at the name Arty.',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1584652991000,
      duration: 7200000,
      id: '83',
      name: 'Muenchner Brainstormers Club: Online meeting',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1585588500000,
      local_date: '2020-03-30',
      local_time: '19:15',
      updated: 1584652991000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 3,
      venue: {
        id: 84,
        name: 'Online',
        lat: 48.13512420654297,
        lon: 11.58198070526123,
        repinned: false,
        address_1: 'Online Adresse noch nicht verfügbar',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1444592791000,
        name: 'Toastmasters Clubs in and around Munich',
        id: 85,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Toastmasters-Clubs-in-and-around-Munich',
        who: 'Toastmaster',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Toastmasters-Clubs-in-and-around-Munich/events/269533417/',
      description: '<p>Wegen Corona finden derzeit meetings ausschließlich online statt.</p> <p>REDEN lernst Du nur durch REDEN!</p> <p>Der größte Teil der Menschen hat davor einen ungeheuren Respekt – sich vor unbekannte Menschen zu stellen und eine Rede halten zu müssen.</p> <p>Wir lernen die Kunst der freien Rede in einem geschützten Rahmen in einer tollen, entspannten, fast familienartigen Atmosphäre. Ein optimal abgestimmtes Trainingsprogramm bringt Dich dazu.</p> <p>- Dein Potential zu entdecken und frei und souverän vor anderen reden zu können.<br/>- Deine Kommunikations, Organisations – und Führungskompetenzen zu optimieren.<br/>- Selbstvertrauen und Deine eigene Persönlichkeit weiter zu entwickeln.</p> <p>Unser Erfolg spricht eine einzigartige Sprache</p> <p>- Wir sind Teil der globalen Toastmasters Organisation mit ca. [masked] Mitglieder und ca. 16.800 Clubs weltweit<br/>- Ein Mitglied war bereits Europameister ……<br/>- Zwei Mitglieder machen sehr erfolgreich Comedy<br/>- Viele Mitglieder sind in Führungspositionen und beherrschen Reden exzellent.<br/>- Gelebte Diversität ist unsere Stärke und gibt uns Kreativität und Tiefe.</p> <p>Du hast immer noch Zweifel?</p> <p>Das ist normal. Sei einfach unser Gast und überzeuge Dich selbst. Es ist ein großartiges Netzwerk von tollen Leuten, der Eintritt kostet Dich nichts. Du wirst überrascht sein, wie wertschätzend der Umgang untereinander ist. Genau die Atmosphäre, die es braucht, sich in einem geschützten Rahmen entwickeln zu können.</p> <p>Gäste sind ohne Voranmeldung willkommen!</p> <p>Der Abend gliedert sich in drei Teile:<br/>- Der erste Teil besteht aus den spontanen Stegreifreden<br/>- Der zweite Teil aus den vorbereiteten Reden<br/>- Der dritte Teil ist für die Rückmeldung der Teilnehmer an die Redner.</p> <p>Der Club trifft sich jeden ersten und dritten Montag des Monats.</p> <p>Der Club trat im Dezember 1997 zum ersten Mal zusammen und wurde im Dezember 1998 von Toastmasters International als Club #9725-U anerkannt.</p> <p>Mehr Information auf der<br/>Toastmaster Website<br/><a href=\'http://bit.ly/Toastmasters-MucBrainstormers\' class=\'linkified\'>http://bit.ly/Toastmasters-MucBrainstormers</a><br/>Auf unserer Homepage:<br/><a href=\'http://bit.ly/Web-MucBrainstormers\' class=\'linkified\'>http://bit.ly/Web-MucBrainstormers</a></p> ',
      how_to_find_us: 'Gäste bitte per E-Mail (vp-pr@munich-brainstormers.de) den Link zum online meeting erfragen.',
      visibility: 'public',
      member_pay_fee: false
    },
    {
      created: 1574174623000,
      duration: 7200000,
      id: '86',
      name: 'AfterWERK meets MUNICH STARTUP.de',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1589990400000,
      local_date: '2020-05-20',
      local_time: '18:00',
      updated: 1579073757000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 23,
      venue: {
        id: 87,
        name: 'Atelierstraße 29',
        lat: 48.12380599975586,
        lon: 11.608274459838867,
        repinned: true,
        address_1: 'Atelierstraße 29',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1458124246000,
        name: 'WERK1',
        id: 88,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'WERK1munich',
        who: 'movers and shakers',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/WERK1munich/events/266581534/',
      description: '<p>Once per month, the Munich Startup Community meets at WERK1 for the famous „Feierabend-Bier“, snacks and wine!</p> <p>Join us for 1-2 pitches &amp; networking. If you are interested in pitching yourself, write to [masked].</p> <p>In a nutshell<br/>– Thursday, 20th May 2020 || 6pm<br/>– Informal networking with snacks &amp; drinks<br/>– Meet Munich Entrepreneurs Startups &amp; Freelancers<br/>– max. 2 startup pitches, 4 minutes each</p> ',
      how_to_find_us: 'Access by car only via \'Piusstraße\', coming by S-Bahn Ostbahnhof enter Werksviertel on \'Speicherstraße\'.',
      visibility: 'public',
      member_pay_fee: false
    }
  ]
};

export { mockEvents };